import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { currentTeam, currentVideoSrc, selectedBBBVideo } from '../../store/translation/selectors';

import {
  videoPanelStyle,
  videoInnerContainerStyle,
  metaInnerContainerStyle,
  isMobileWidthVideoPanel,
} from '../../store/screen/panelSelectors';

import fade from '../../styles/transitions/fade.module.css';
import styles from './styles.module.css';
import { RootState } from '../../store';
import ActionBar from './ActionBar';
import MetadataBar from './MetadataBar';
import CopyrightBar from './CopyrightBar';
import Arrow from './Arrow';
import MainVideoPlayer from '../MainVideoPlayer';
import LoadingIndicator from '../LoadingIndicator';
import { isMobile } from '../../store/screen/selectors';
import BBBResourceMain from '../MainVideoPlayer/BBBResourcesLayouts/BBBResourceMain';
import { getBBBResources } from '../../utils/api/getTranslation';
import { RecordItem } from '../MainVideoPlayer/BBBResourcesLayouts/types';

const VideoPanel = (): JSX.Element => {
  const [showBBBResourceMain, setShowBBBResourceMain] = useState(false);
  const [bbbResources, setBbbResources] = useState<RecordItem[]>([]);

  const { darkMode } = useSelector((state: RootState) => state.settings);
  const { panelPosition } = useSelector((state: RootState) => state.textPanelSettings);
  const innerContainerStyle = useSelector(videoInnerContainerStyle);
  const metaContainerStyle = useSelector(metaInnerContainerStyle);
  const outerContainerStyle = useSelector(videoPanelStyle);
  const videoSrc = useSelector(currentVideoSrc);
  const isMobileDevice = useSelector(isMobile);
  const isMobileVideoPanel = useSelector(isMobileWidthVideoPanel);
  const selectedVideo = useSelector(selectedBBBVideo);
  const team = useSelector(currentTeam);

  const addPadding = !isMobileDevice && isMobileVideoPanel && panelPosition === 'left';
  const innerContainer = `${styles.innerContainer} ${darkMode && styles.innerContainerDarkMode}`;
  const outerContainer = `${styles.outerContainer} ${
    addPadding && styles.outerContainerMobileWithTab
  } ${isMobileDevice && styles.outerContainerMobile}`;

  const show = videoSrc !== undefined;
  const loadingIndicatorImg = team?.icon_url;

  const openBBBResourceMain = () => {
    setShowBBBResourceMain(true);
  };

  const closeBBBResourceMain = () => {
    setShowBBBResourceMain(false);
  };

  useEffect(() => {
    if (selectedVideo && selectedVideo.bbb_id) {
      getBBBResources(selectedVideo.bbb_id).then(records => {
        setBbbResources(records);
      });
    }
  }, [selectedVideo]);

  useEffect(() => {
    setShowBBBResourceMain(false);
  }, [videoSrc]);

  return (
    <CSSTransition in={show} classNames={fade} timeout={300} mountOnEnter unmountOnExit>
      <div className={outerContainer} style={outerContainerStyle}>
        {isMobileDevice && (
          <CSSTransition
            in={showBBBResourceMain}
            classNames={fade}
            timeout={300}
            mountOnEnter
            unmountOnExit
          >
            <div
              className={`${styles.bbbResourceContainer} ${
                showBBBResourceMain
                  ? styles.bbbResourceContainerShow
                  : styles.bbbResourceContainerHide
              }`}
            >
              <BBBResourceMain
                closeBBBResourceMain={closeBBBResourceMain}
                bbbResources={bbbResources}
                isMobileDevice={isMobileDevice}
                isDarkMode={darkMode}
              />
            </div>
          </CSSTransition>
        )}
        <div className={styles.mainContainer}>
          <div className={innerContainer} style={innerContainerStyle}>
            <div className={styles.arrowsContainer}>
              <Arrow direction="prev" />
              <Arrow direction="next" />
            </div>
            <LoadingIndicator imgUrl={loadingIndicatorImg} isMobile={isMobileDevice} />
            <div style={{ position: 'relative' }}>
              <div>
                <MainVideoPlayer open={openBBBResourceMain} bbbResources={bbbResources} />
              </div>
              {!isMobileDevice && (
                <CSSTransition
                  in={showBBBResourceMain}
                  classNames={fade}
                  timeout={300}
                  mountOnEnter
                  unmountOnExit
                >
                  <div
                    className={`${styles.bbbResourceContainer} ${
                      showBBBResourceMain
                        ? styles.bbbResourceContainerShow
                        : styles.bbbResourceContainerHide
                    }`}
                  >
                    <BBBResourceMain
                      closeBBBResourceMain={closeBBBResourceMain}
                      bbbResources={bbbResources}
                      isMobileDevice={isMobileDevice}
                      isDarkMode={darkMode}
                    />
                  </div>
                </CSSTransition>
              )}
            </div>
          </div>
          <div className={innerContainer} style={metaContainerStyle}>
            <ActionBar />
            <MetadataBar />
            <CopyrightBar />
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default VideoPanel;
